import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import theme from "src/theme";
import {
  Grid,
  Typography,
  Button,
  CircularProgress,
  Link,
  Select,
  MenuItem,
  Box,
  InputLabel,
  makeStyles,
  Snackbar,
} from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import logo from "src/assets/images/conexoplus.png";

import { recuperarSenha } from "src/store/actions/usuario";
import * as types from "src/store/types/usuario";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "grid",
    gridTemplateAreas: "'logo form'",
    gridTemplateRows: "100vh",
    gridTemplateColumns: "1fr 1fr",
    [theme.breakpoints.down("sm")]: {
      gridTemplateAreas: "'logo''form'",
      gridTemplateColumns: "1fr",
      gridTemplateRows: "30vh 50vh",
    },
  },
  logo: {
    gridArea: "logo",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      alignItems: "flex-end",
    },
  },
  form: {
    gridArea: "form",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
    },
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function RecuperarSenha() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading } = useSelector(
    (state) => state.usuario
  );
  const [data, setData] = useState({ email: "" });
  const [openError, setOpenError] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);

  const handleCloseError = () => {
    setOpenError(false);
  }
  const handleCloseSuccess = () => {
    setOpenSuccess(false);
  }

  const handleRecuperarSenha = async () => {
    dispatch({ type: types.USUARIO_LOADING, payload: true });
    try {
      await recuperarSenha(data.email);
      setOpenSuccess(true);
    
    } catch(error) {
      setOpenError(true);
    }
  }

  return (
    <Box className={classes.container}>
      <Box className={classes.logo}>
        <img
          src={logo}
          alt="Logomarca Conexo Mais"
          style={{ width: 280, height: 120 }}
        />
      </Box>
      <Box className={classes.form}>
        <Snackbar open={openError} autoHideDuration={5000} onClose={handleCloseError} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          <Alert onClose={handleCloseError} severity="error">
            Este e-mail não foi encontrado.
          </Alert>
        </Snackbar>
        <Snackbar open={openSuccess} autoHideDuration={5000} onClose={handleCloseSuccess} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          <Alert onClose={handleCloseSuccess} severity="success">
            Um e-mail foi enviado para você com um link para alterar sua senha.
          </Alert>
        </Snackbar>
        <ValidatorForm
          onSubmit={handleRecuperarSenha}
          onError={(errors) => console.log(errors)}
          style={{ width: "clamp(300px, 100%, 500px)" }}
        >
          <Typography variant="h2">Recuperar Senha</Typography>
          <Grid container spacing={2} style={{ marginTop: 20 }}>
            <Grid item sm={12}>
              <TextValidator
                fullWidth
                label="E-Mail"
                name="E-Mail"
                onChange={(event) =>
                  setData({
                    ...data,
                    email: event.target.value,
                  })
                }
                type="text"
                value={data.email}
                variant="outlined"
                validators={["required", "isEmail"]}
                errorMessages={[
                  "este campo é obrigatório",
                  "não é um e-mail válido",
                ]}
              />
            </Grid>
          </Grid>
          {loading ? (
            <CircularProgress
              style={{
                display: "block",
                width: 45,
                height: 45,
                marginTop: 25,
                marginLeft: "auto",
                marginRight: "auto",
              }}
            />
          ) : (
            <div>
              <Button
                type="submit"
                style={{
                  marginTop: 25,
                  width: "100%",
                  "&:hover": {
                    backgroundColor: theme.palette.common.rozaPtz,
                  },
                }}
                color="primary"
                size="large"
                variant="contained"
              >
                Enviar E-Mail
              </Button>
            </div>
          )}
          <Typography
            variant="body1"
            style={{
              marginTop: 10,
              color: theme.palette.text.secondary,
            }}
          >
            <Link
              href="/"
              style={{
                "&:hover": {
                  cursor: "pointer",
                  color: "#000 !important",
                },
              }}
            >
              Voltar para página inicial
            </Link>
          </Typography>
        </ValidatorForm>
      </Box>
    </Box>
  );
}

export default RecuperarSenha;